import React from 'react';
import { MobileLayout } from '../components/MobileLayout';
import { User, Bell, Lock, CreditCard, Globe, HelpCircle } from 'lucide-react';
export function ImpostazioniPage() {
  return <MobileLayout data-id="element-691">
      {/* Page Header */}
      <div className="mb-6 lg:mb-8" data-id="element-692">
        <h1 className="text-xl lg:text-2xl font-montserrat font-bold text-navy" data-id="element-693">
          Impostazioni
        </h1>
        <p className="text-xs lg:text-sm text-gray-500 mt-1" data-id="element-694">
          Gestisci le preferenze del tuo account
        </p>
      </div>

      {/* Settings Sections */}
      <div className="space-y-4" data-id="element-695">
        {/* Account Section */}
        <div className="bg-white rounded-xl border border-gray-200 p-4 lg:p-6" data-id="element-696">
          <h2 className="text-sm font-semibold text-navy mb-4 flex items-center gap-2" data-id="element-697">
            <User size={18} data-id="element-698" />
            Account
          </h2>
          <div className="space-y-3" data-id="element-699">
            <button className="w-full flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition-colors text-left min-h-[44px]" data-id="element-700">
              <span className="text-sm text-navy" data-id="element-701">Profilo</span>
              <span className="text-xs text-gray-400" data-id="element-702">›</span>
            </button>
            <button className="w-full flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition-colors text-left min-h-[44px]" data-id="element-703">
              <span className="text-sm text-navy" data-id="element-704">Email e Password</span>
              <span className="text-xs text-gray-400" data-id="element-705">›</span>
            </button>
          </div>
        </div>

        {/* Notifications Section */}
        <div className="bg-white rounded-xl border border-gray-200 p-4 lg:p-6" data-id="element-706">
          <h2 className="text-sm font-semibold text-navy mb-4 flex items-center gap-2" data-id="element-707">
            <Bell size={18} data-id="element-708" />
            Notifiche
          </h2>
          <div className="space-y-3" data-id="element-709">
            <button className="w-full flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition-colors text-left min-h-[44px]" data-id="element-710">
              <span className="text-sm text-navy" data-id="element-711">Preferenze Notifiche</span>
              <span className="text-xs text-gray-400" data-id="element-712">›</span>
            </button>
          </div>
        </div>

        {/* Security Section */}
        <div className="bg-white rounded-xl border border-gray-200 p-4 lg:p-6" data-id="element-713">
          <h2 className="text-sm font-semibold text-navy mb-4 flex items-center gap-2" data-id="element-714">
            <Lock size={18} data-id="element-715" />
            Sicurezza
          </h2>
          <div className="space-y-3" data-id="element-716">
            <button className="w-full flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition-colors text-left min-h-[44px]" data-id="element-717">
              <span className="text-sm text-navy" data-id="element-718">
                Autenticazione a due fattori
              </span>
              <span className="text-xs text-gray-400" data-id="element-719">›</span>
            </button>
          </div>
        </div>

        {/* Billing Section */}
        <div className="bg-white rounded-xl border border-gray-200 p-4 lg:p-6" data-id="element-720">
          <h2 className="text-sm font-semibold text-navy mb-4 flex items-center gap-2" data-id="element-721">
            <CreditCard size={18} data-id="element-722" />
            Fatturazione
          </h2>
          <div className="space-y-3" data-id="element-723">
            <button className="w-full flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition-colors text-left min-h-[44px]" data-id="element-724">
              <span className="text-sm text-navy" data-id="element-725">Metodi di Pagamento</span>
              <span className="text-xs text-gray-400" data-id="element-726">›</span>
            </button>
            <button className="w-full flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition-colors text-left min-h-[44px]" data-id="element-727">
              <span className="text-sm text-navy" data-id="element-728">Storico Fatture</span>
              <span className="text-xs text-gray-400" data-id="element-729">›</span>
            </button>
          </div>
        </div>

        {/* Language Section */}
        <div className="bg-white rounded-xl border border-gray-200 p-4 lg:p-6" data-id="element-730">
          <h2 className="text-sm font-semibold text-navy mb-4 flex items-center gap-2" data-id="element-731">
            <Globe size={18} data-id="element-732" />
            Lingua e Regione
          </h2>
          <div className="space-y-3" data-id="element-733">
            <button className="w-full flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition-colors text-left min-h-[44px]" data-id="element-734">
              <span className="text-sm text-navy" data-id="element-735">Lingua</span>
              <span className="text-xs text-gray-500" data-id="element-736">Italiano</span>
            </button>
          </div>
        </div>

        {/* Help Section */}
        <div className="bg-white rounded-xl border border-gray-200 p-4 lg:p-6" data-id="element-737">
          <h2 className="text-sm font-semibold text-navy mb-4 flex items-center gap-2" data-id="element-738">
            <HelpCircle size={18} data-id="element-739" />
            Supporto
          </h2>
          <div className="space-y-3" data-id="element-740">
            <button className="w-full flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition-colors text-left min-h-[44px]" data-id="element-741">
              <span className="text-sm text-navy" data-id="element-742">Centro Assistenza</span>
              <span className="text-xs text-gray-400" data-id="element-743">›</span>
            </button>
            <button className="w-full flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition-colors text-left min-h-[44px]" data-id="element-744">
              <span className="text-sm text-navy" data-id="element-745">Contattaci</span>
              <span className="text-xs text-gray-400" data-id="element-746">›</span>
            </button>
          </div>
        </div>

        {/* Logout Button */}
        <button className="w-full px-4 py-3 border border-red-200 text-red-600 rounded-lg hover:bg-red-50 transition-colors text-sm font-medium min-h-[44px]" data-id="element-747">
          Esci dall'Account
        </button>
      </div>
    </MobileLayout>;
}